import React from "react";
import { Text, cn } from "@fmc-digital/ui";
import { loginHeaderStyles } from "./login-header.styles";

export interface LoginHeaderProps {
  /**
   * Title text to display
   */
  title: string;
  
  /**
   * Description text to display below title
   */
  description: string;
  
  /**
   * Optional test ID for testing
   * @default "login-header"
   */
  testId?: string;
  
  /**
   * Optional className for additional styling
   */
  className?: string;
}

/**
 * LoginHeader molecule component
 * Custom header for login page matching Figma design specifications
 * - Title: 45px, Canela Text, Bold, color #003049 (primary)
 * - Description: 16px, Poppins Medium, color #191c1e (on-background)
 * - Gap: 12px between title and description
 * Uses CSS-based responsive styling instead of JavaScript conditionals
 */
export const LoginHeader: React.FunctionComponent<LoginHeaderProps> = ({
  title,
  description,
  testId = "login-header",
  className,
}) => {
  return (
    <div
      className={cn(loginHeaderStyles(), className)}
      data-testid={testId}
    >
      {/* Title - 45px, Canela Text, Bold per Figma */}
      <h1 className="text-[45px] font-bold text-primary leading-normal mt-0 mb-0" style={{ fontFamily: "'Canela Text'" }}>
        {title}
      </h1>
      
      {/* Description - 16px, Poppins Medium per Figma */}
      <Text 
        variant="bodyLarge" 
        className="text-on-background font-medium"
        style={{
          color: 'var(--Schemes-On-Background, #191C1E)',
          fontFamily: 'Poppins',
          fontSize: 'var(--Static-Body-Large-Size, 16px)',
          fontStyle: 'normal',
          fontWeight: 500,
          lineHeight: 'var(--Static-Body-Large-Line-Height, 24px)',
          letterSpacing: 'var(--Static-Body-Large-Tracking, 0.5px)',
        }}
      >
        {description}
      </Text>
    </div>
  );
};
